import * as actionTypes from '../actions/recordList/constants';

const initFiltersValue = {
  value: null,
  error: null,
};

const searchfilters = {
  creationDateMin: initFiltersValue,
  creationDateMax: initFiltersValue,
  entryStockDateMax: initFiltersValue,
  entryStockDateMin: initFiltersValue,
  refHexaId: initFiltersValue,
  registration: initFiltersValue,
  vin: initFiltersValue,
  brandName: initFiltersValue,
  modelName: initFiltersValue,
  registrationDate: initFiltersValue,
  concessionId: initFiltersValue,
  userId: initFiltersValue,
  status: initFiltersValue,
  clic2sell: initFiltersValue,
  clic2buy: initFiltersValue,
  recordTypeId: initFiltersValue,
  guaranteedPrice: initFiltersValue,
  sourceIds: initFiltersValue,
  nrmStatus: initFiltersValue,
  nrmRecordId: initFiltersValue,
  cancelCases: initFiltersValue,
  carcheck: initFiltersValue,
  stellaClub: initFiltersValue,
  pushToStockSale: initFiltersValue,
  pushToCoverage: initFiltersValue,
};

const initialState = {
  loading: false, // loader
  records: [],
  error: false,
  counts: {},
  currentPage: 1,
  pageCount: 1,
  recordPerPage: 10,
  currentTab: null,
  filters: searchfilters,
  filtersSupervisor: {},
  sort: [],
  selectedPos: 'privatePos',
};
const recordListReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_RECORDS_REQUEST: {
      return {
        ...state,
        records: [],
        loading: true,
        error: false,
      };
    }
    case actionTypes.FETCH_RECORDS_SUCCESS: {
      const { records: newRecords, type, count, onlyCount } = action.payload;
      const { counts } = state;
      return {
        ...state,
        loading: false,
        ...(!onlyCount && { records: [...newRecords] }),
        counts: { ...counts, [type]: count },
        error: false,
      };
    }

    case actionTypes.FETCH_RECORDS_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }

    case actionTypes.CHANGE_PAGE: {
      const { page } = action.payload;
      return {
        ...state,
        currentPage: page,
      };
    }

    case actionTypes.CHANGE_TAB: {
      const { tab } = action.payload;
      return {
        ...state,
        currentTab: tab,
      };
    }

    case actionTypes.FETCH_RECORDS_COUNT_SUCCESS: {
      return {
        ...state,
        loading: false,
        counts: { ...state.counts, ...action.payload },
      };
    }

    case actionTypes.SET_FILTER: {
      const { name } = action.payload;
      const value = { value: action.payload.value, error: null };
      return {
        ...state,
        filters: { ...state.filters, [name]: value },
      };
    }

    case actionTypes.SET_FILTER_ERROR: {
      const { name, value } = action.payload;
      return {
        ...state,
        filters: { ...state.filters, [name]: { value: null, error: value } },
      };
    }

    case actionTypes.RESET_FILTERS: {
      return {
        ...state,
        filters: { ...searchfilters },
        sort: [],
      };
    }

    case actionTypes.INIT_SEARCH_PAGE: {
      return {
        ...state,
        records: [],
        currentTab: 'search',
      };
    }

    case actionTypes.RESET_COUNT_CURRENTPAGE_PAGECOUNT: {
      return {
        ...state,
        count: {},
        currentPage: 1,
        pageCount: 1,
      };
    }

    case actionTypes.SET_FILTER_SUPERVISOR: {
      const { filters } = action.payload;
      return {
        ...state,
        currentPage: 1,
        filtersSupervisor: { ...filters },
      };
    }

    case actionTypes.RESET_STATE:
      return initialState;

    case actionTypes.SET_SORT: {
      const { sort } = action.payload;
      return {
        ...state,
        sort,
      };
    }

    case actionTypes.FETCH_USER_FEEDS: {
      return {
        ...state,
        totalFeeds: action.payload,
      };
    }

    case actionTypes.CHANGE_POS: {
      const { pos } = action.payload;
      return {
        ...state,
        records: [],
        selectedPos: pos,
      };
    }
    default: {
      return state;
    }
  }
};

export default recordListReducer;
